import { render, staticRenderFns } from "./Paginator.vue?vue&type=template&id=dada02c6&scoped=true"
import script from "./Paginator.vue?vue&type=script&lang=js"
export * from "./Paginator.vue?vue&type=script&lang=js"
import style0 from "./Paginator.vue?vue&type=style&index=0&id=dada02c6&prod&scoped=true&lang=css"
import style1 from "./Paginator.vue?vue&type=style&index=1&id=dada02c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dada02c6",
  null
  
)

export default component.exports